import React from 'react';
import {
  Calculator,
  Download,
  Folders,
  Landmark,
  LayoutDashboard,
  Receipt,
  Scale,
  ScrollText,
  ShieldAlert,
  ShieldCheck,
  SlidersHorizontal,
  CircleDollarSign,
  UserPlus,
  Users,
  Wallet,
} from 'lucide-react';

const SIDEBAR_ICON_CLASS = 'size-6 shrink-0';
const SIDEBAR_ICON_STROKE = 1.5;

function sidebarIcon(Icon: React.ComponentType<{ className?: string; strokeWidth?: number }>) {
  return <Icon className={SIDEBAR_ICON_CLASS} strokeWidth={SIDEBAR_ICON_STROKE} />;
}

export const iconMap: Record<string, React.ReactNode> = {
  'objects-column': sidebarIcon(LayoutDashboard),
  wallet: sidebarIcon(Wallet),
  receipt: sidebarIcon(Receipt),
  folders: sidebarIcon(Folders),
  'money-from-bracket': sidebarIcon(Download),
  'user-plus': sidebarIcon(UserPlus),
  calculator: sidebarIcon(Calculator),
  landmark: sidebarIcon(Landmark),
  scale: sidebarIcon(Scale),
  'scroll-text': sidebarIcon(ScrollText),
  'shield-alert': sidebarIcon(ShieldAlert),
  'shield-check': sidebarIcon(ShieldCheck),
  sliders: sidebarIcon(SlidersHorizontal),
  'circle-dollar': sidebarIcon(CircleDollarSign),
  users: sidebarIcon(Users),
};

export function getIcon(iconName: string): React.ReactNode {
  return iconMap[iconName] ?? sidebarIcon(LayoutDashboard);
}
